import { render, staticRenderFns } from "./pesquisas.vue?vue&type=template&id=420b2e7a&"
import script from "./pesquisas.vue?vue&type=script&lang=js&"
export * from "./pesquisas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports